import React from "react";
import { useIntl } from "react-intl";
import { PeekButton, PeekDivider, PeekSkeleton, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { AnalyticsArea, useTrackEvent } from "@hooks";
import messages from "./messages.i18n";
// Uneven on purpose: category names are words, not blocks.
const SKELETON_WIDTHS = [48, 72, 64, 56, 80, 60];
export const InPageSectionNav = ({ sections, activeSectionId, page, label, onSectionClick, }) => {
    const intl = useIntl();
    const theme = useTheme();
    const track = useTrackEvent();
    const handleSectionClick = (sectionId) => {
        track(AnalyticsArea.Navigation, "Section Jumped", { page, sectionId });
        onSectionClick(sectionId);
    };
    // No sections yet is a loading state, not an empty one: this nav only exists on pages whose
    // sections come from the report, so it holds its shape instead of collapsing the header.
    const isLoading = !sections.length;
    return (React.createElement(PeekStack, { direction: "row", alignItems: "center", gap: 1.5, "aria-label": intl.formatMessage(messages.scrollTo), sx: { flexWrap: "wrap" } },
        label !== null && (React.createElement(PeekTypography, { variant: "h4", color: theme.palette.grey[300] }, label !== null && label !== void 0 ? label : intl.formatMessage(messages.scrollTo))),
        isLoading &&
            SKELETON_WIDTHS.map((width, index) => (React.createElement(PeekStack, { key: index, direction: "row", alignItems: "center", gap: 1.5 },
                index > 0 && React.createElement(PeekDivider, { orientation: "vertical", light: true, flexItem: true, sx: { my: 0.5 } }),
                React.createElement(PeekSkeleton, { variant: "text", width: width, sx: { fontSize: "h4.fontSize" } })))),
        sections.map((section, index) => {
            const isActive = section.id === activeSectionId;
            return (React.createElement(PeekStack, { key: section.id, direction: "row", alignItems: "center", gap: 1.5 },
                index > 0 && React.createElement(PeekDivider, { orientation: "vertical", light: true, flexItem: true, sx: { my: 0.5 } }),
                React.createElement(PeekButton, { variant: "text", onClick: () => handleSectionClick(section.id), "aria-current": isActive ? "true" : undefined, sx: {
                        minWidth: 0,
                        p: 0,
                        color: isActive ? theme.palette.teal[600] : theme.palette.text.primary,
                        textDecoration: isActive ? "underline" : "none",
                        textUnderlineOffset: 4,
                        fontWeight: isActive ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
                        "&:hover": { background: "none", textDecoration: "underline" },
                    } },
                    React.createElement(PeekTypography, { variant: "h4", color: "inherit", fontWeight: "inherit" }, section.label))));
        })));
};
export default InPageSectionNav;
